// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2zMPM","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3hytQ"};